import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import type { CtrlApiClient, CtrlApiConfig } from "@repo/sdk";

type CtrlApiContextObj = {
  client: CtrlApiClient;
  config: CtrlApiConfig;
};

const CtrlApiContext = createContext<CtrlApiContextObj | null>(null);

export function useCtrlClient(): CtrlApiClient {
  const context = useContext(CtrlApiContext);
  if (!context) {
    throw new Error("useCtrlClient must be used within a CtrlApiProvider");
  }
  return context.client;
}

export function useCtrlConfig(): CtrlApiConfig {
  const context = useContext(CtrlApiContext);
  if (!context) {
    throw new Error("useCtrlConfig must be used within a CtrlApiProvider");
  }
  return context.config;
}

type CtrlApiProviderProps = PropsWithChildren<{
  client: CtrlApiClient;
  config: CtrlApiConfig;
}>;

export function CtrlApiProvider({ client, config, children }: CtrlApiProviderProps) {
  return (
    <CtrlApiContext.Provider value={{ client, config }}>
      {children}
    </CtrlApiContext.Provider>
  );
}
